import React, { Component } from "react";
import "../../styles/components/Sliders/NextSliders.css";
class NextSliders extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="second-slider-middle-next">
        <div className="more-slider-section">
          <div className="top-section">
            <div className="news-top-left">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSxxllzNgGgILqzIL_FJxPKgXP_FhHEhFokaackIGN0CUzhoVU"
                className="photo-wrapper"
                alt=""
              />
              <a href>Komisioni</a>
            </div>
            <div className="news-top-right">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSxxllzNgGgILqzIL_FJxPKgXP_FhHEhFokaackIGN0CUzhoVU"
                className="photo-wrapper"
                alt=""
              />
              <a href>Komisioni</a>
            </div>
          </div>
          <div className="bottom-section">
            <div className="news-bottom-left">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSxxllzNgGgILqzIL_FJxPKgXP_FhHEhFokaackIGN0CUzhoVU"
                className="photo-wrapper"
                alt=""
              />
              <a href>Komisioni</a>
            </div>
            <div className="news-bottom-right">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSxxllzNgGgILqzIL_FJxPKgXP_FhHEhFokaackIGN0CUzhoVU"
                className="photo-wrapper"
                alt=""
              />
              <a href>Komisioni</a>
            </div>
          </div>
        </div>
        <div className="more-slider-section">
          <div className="top-section">
            <div className="news-top-left">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSxxllzNgGgILqzIL_FJxPKgXP_FhHEhFokaackIGN0CUzhoVU"
                className="photo-wrapper"
                alt=""
              />
              <a href>Komisioni</a>
            </div>
            <div className="news-top-right">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSxxllzNgGgILqzIL_FJxPKgXP_FhHEhFokaackIGN0CUzhoVU"
                className="photo-wrapper"
                alt=""
              />
              <a href>Komisioni</a>
            </div>
          </div>
          <div className="bottom-section">
            <div className="news-bottom-left">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSxxllzNgGgILqzIL_FJxPKgXP_FhHEhFokaackIGN0CUzhoVU"
                className="photo-wrapper"
                alt=""
              />
              <a href>Komisioni</a>
            </div>
            <div className="news-bottom-right">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSxxllzNgGgILqzIL_FJxPKgXP_FhHEhFokaackIGN0CUzhoVU"
                className="photo-wrapper"
                alt=""
              />
              <a href>Komisioni</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default NextSliders;
